<div [class]="floating() ? floatingPageClasses() + ' min-h-full' : ''">
  <p
    class="text-2xl font-semibold"
    [class]="floating() ? 'mb-lg' : 'mb-2xl pb-lg border-b border-neutral-200'">
    {{ 'logs_list_screen_title' | transloco }}
  </p>

  <section
    [class]="floating() ? 'floating-card p-2xl block' : 'contents'"
    data-testid="logs-list-section">
    <!-- UI_Version_2: no title or count row; the search is in the table toolbar -->
    @if (!floating() || !searchInToolbar()) {
      <div class="flex justify-between items-center gap-lg">
        <div class="flex items-center gap-sm min-w-0">
          @if (!floating()) {
            <p class="text-lg font-semibold text-neutral-900">
              {{ 'logs_list_screen_sub_title' | transloco }}
            </p>
            <lib-badge
              label="{{ totalCount() }}"
              [badgeClass]="'px-sm border-none text-sm font-medium bg-primary-50 text-primary-600'" />
          }
        </div>

        <!-- Tables_new_design shows the search in the table toolbar instead -->
        @if (!searchInToolbar()) {
          <ng-container [ngTemplateOutlet]="logsSearch" />
        }
      </div>
    }

    <ng-template #logsSearch>
      <lib-search-field
        class="shrink-0"
        [searchInputWidth]="searchInputWidth"
        [placeholder]="'search by action name, log id or Reference ID'"
        (searchKeywordEmitter)="onSearchTermChange($event)" />
    </ng-template>

    <div>
      <lib-table
        [id]="'logs'"
        [tableClass]="'min-h-[calc(100vh-28.5rem)] h-auto w-full whitespace-nowrap'"
        [tableAction]="false"
        [dataSource]="dataSource()"
        [loading]="isLoading()"
        [tableTitle]="
          floating() ? '' : ('logs_list_screen_table_title' | transloco)
        "
        [columns]="columns()"
        [noDataTitle]="'table_no_data_title' | transloco"
        [noDataDescription]="'table_no_data_description' | transloco"
        [tableFilterTabs]="tableFilterTabs()"
        [viewCount]="totalCount()"
        [filterDropdownTemplateRef]="filterDropdown"
        [searchTemplateRef]="searchInToolbar() ? logsSearch : null"
        (handleSortColumn)="handleSortColumn($event)"
        [bodyTemplateRef]="[
          number,
          log_id,
          time_stamp,
          user_name,
          action_name,
          action_type,
          module,
          reference_id,
        ]">
        <ng-template #number let-i="i">
          {{ (currentPage() - 1) * currentSize() + (i + 1) }}
        </ng-template>

        <ng-template #log_id let-row> ID-{{ row.id }} </ng-template>

        <ng-template #time_stamp let-row>
          <span dir="ltr">
            {{ row.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
          </span>
        </ng-template>

        <ng-template #user_name let-row>
          @if (row.causer) {
            <div class="flex items-center gap-md">
              <lib-avatar
                [fullName]="row.causer.name"
                [img]="row.causer?.image?.url"
                borderRadius="rounded-full" />
              <span class="text-xs font-medium text-neutral-900">
                {{ row.causer.name }}
              </span>
            </div>
          }
        </ng-template>

        <ng-template #action_name let-row>
          {{ row.description }}
        </ng-template>

        <ng-template #action_type let-row>
          {{ row.event.label }}
        </ng-template>

        <ng-template #module let-row>
          {{ row.subject_type.label }}
        </ng-template>

        <ng-template #reference_id let-row>
          {{ row.subject_id }}
        </ng-template>

        <ng-template #filterDropdown>
          <lib-filter-dropdown
            [filterOptions]="filterOptions"
            [initialValues]="initialFilterValues()"
            (applyFilters)="onApplyFilters($event)" />
        </ng-template>
      </lib-table>
    </div>

    @if (dataSource().length) {
      <div [class]="floating() ? 'pt-2xl' : 'py-2xl'">
        <lib-paginator
          [sizeOptionsLabel]="
            'pagination_number_of_rows_per_page_label' | transloco
          "
          [nextBtnLabel]="'pagination_next_button_label' | transloco"
          [previousBtnLabel]="'pagination_previous_button_label' | transloco"
          [currentPage]="currentPage()"
          [totalPages]="totalPages()"
          [totalItems]="totalCount()"
          [showChangeSize]="true"
          [sizeOptions]="pageSizeOptions"
          (goTo)="handlePagination($event)"
          (next)="handlePagination($event)"
          (previous)="handlePagination($event)"
          (handleChangeSize)="changeSize($event)"
          [currentSize]="currentSize()"></lib-paginator>
      </div>
    }
  </section>
</div>
